import { render, staticRenderFns } from "./CreateAnnouncementTypePage.vue?vue&type=template&id=d67a5782&scoped=true"
import script from "./CreateAnnouncementTypePage.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncementTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67a5782",
  null
  
)

export default component.exports